import { render, staticRenderFns } from "./work-index-item.vue?vue&type=template&id=43953549&scoped=true"
import script from "./work-index-item.vue?vue&type=script&lang=js"
export * from "./work-index-item.vue?vue&type=script&lang=js"
import style0 from "./work-index-item.vue?vue&type=style&index=0&id=43953549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43953549",
  null
  
)

export default component.exports